"use client";

import * as React from "react";
import { Select as RadixSelect } from "@radix-ui/themes";
import cx from "clsx";
import { useElement } from "../widgets-context.js";
import { getDomProps, namespaceClassNames } from "../utils.js";

interface TriggerProps extends Omit<RadixSelect.TriggerProps, "variant"> {}

const SelectTrigger = React.forwardRef<HTMLButtonElement, TriggerProps>(
  function SelectTrigger({ className, ...props }, ref) {
    const element = useElement("select");
    return (
      <RadixSelect.Trigger
        ref={ref}
        {...getDomProps({ elementId: "select", className })}
        {...props}
        {...element}
      />
    );
  },
);

interface ContentProps extends Omit<RadixSelect.ContentProps, "variant"> {}

const SelectContent = React.forwardRef<HTMLDivElement, ContentProps>(
  function SelectContent({ className, ...props }, ref) {
    const element = useElement("dropdown");
    return (
      <RadixSelect.Content
        ref={ref}
        {...getDomProps({
          elementId: "dropdown",
          // TODO: This should probably be removed in the next major version. We
          // should have a consistent way to differentiate between dropdowns and
          // selects in the elements API.
          className: cx(className, namespaceClassNames("select-dropdown")),
        })}
        {...props}
        {...element}
      />
    );
  },
);

interface ItemProps extends Omit<RadixSelect.ItemProps, "variant"> {}

const SelectItem = React.forwardRef<HTMLDivElement, ItemProps>(
  function SelectItem({ className, ...props }, ref) {
    const element = useElement("primaryMenuItem");
    return (
      <RadixSelect.Item
        ref={ref}
        {...getDomProps({
          elementId: "primaryMenuItem",
          // TODO: This should probably be removed in the next major version. We
          // should have a consistent way to differentiate between dropdowns and
          // selects in the elements API.
          className: cx(className, namespaceClassNames("select-item")),
        })}
        {...props}
        {...element}
      />
    );
  },
);

export {
  SelectTrigger as Trigger,
  SelectContent as Content,
  SelectItem as Item,
};

export type { TriggerProps, ContentProps, ItemProps };

export {
  Group,
  Label,
  Root,
  Separator,
} from "@radix-ui/themes/components/select";
export type {
  GroupProps,
  LabelProps,
  RootProps,
  SeparatorProps,
} from "@radix-ui/themes/components/select";
